import { render, staticRenderFns } from "./PasswordViewSidebar.vue?vue&type=template&id=2ac2c48f&scoped=true&"
import script from "./PasswordViewSidebar.vue?vue&type=script&lang=js&"
export * from "./PasswordViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PasswordViewSidebar.vue?vue&type=style&index=0&id=2ac2c48f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2c48f",
  null
  
)

export default component.exports